import { useMemo, useState } from 'react';
import { ErpInputTableV2 } from '@/components/custom/erp';
import { getDetailTableColumnsV2 } from './columns';

interface DetailTabProps {
  rows: { uuid?: string | null }[];
  detailColumns?: any[];
  selectedRowUuid?: string | null;
  selectedRowIds?: string[];
  onRowClick?: (params: any) => void;
  onRowSelectionChange?: (selectedIds: string[]) => void;
}

export default function DetailTab({
  rows,
  detailColumns,
  selectedRowUuid,
  selectedRowIds = [],
  onRowClick,
  onRowSelectionChange
}: DetailTabProps) {
  const [currentPage, setCurrentPage] = useState(0);
  const columns = useMemo(() => detailColumns || getDetailTableColumnsV2(), [detailColumns]);

  return (
    <div className='flex h-full min-h-0 w-full flex-col'>
      <ErpInputTableV2
        rows={rows}
        columns={columns as any[]}
        checkboxSelection
        showIndexColumn
        selectedRowId={selectedRowUuid || undefined}
        selectedRowIds={selectedRowIds}
        onRowClick={onRowClick}
        onRowSelectionChange={onRowSelectionChange}
        getRowId={row => String(row?.uuid || '')}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        pageSize={100}
        rowHeight={40}
        height='100%'
        widthMode='stretch'
        scrollMode='auto'
        hideEmptyState={false}
        className='h-full w-full flex-1'
        tableClassName='[&_tbody_td]:px-2 [&_tbody_td]:py-0.5 [&_tbody_td>div]:py-0 [&_thead_th]:px-2'
      />
    </div>
  );
}
